'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'chart-network';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f78a';
var svgPathData = 'M160 64C160 28.65 188.7 0 224 0C259.3 0 288 28.65 288 64C288 83.36 279.4 100.7 265.8 112.5L304.3 196.5C314.4 193.6 325 192 336 192C367.7 192 396.2 205.1 416.6 226.2L517.4 153.7C513.9 145.8 512 137.1 512 128C512 92.65 540.7 64 576 64C611.3 64 640 92.65 640 128C640 163.3 611.3 192 576 192C561.4 192 547.9 187.1 537.2 178.9L435.3 252.2C443.4 267.7 448 285.3 448 304C448 319.4 444.9 334 439.3 347.3L531.1 402.4C542.6 391 558.5 384 576 384C611.3 384 640 412.7 640 448C640 483.3 611.3 512 576 512C540.7 512 512 483.3 512 448C512 441.7 512.9 435.6 514.6 429.8L422.8 374.8C402.3 399.9 371 416 336 416C279.6 416 232.9 374.3 225.1 320H125.1C118.9 347.6 93.82 368 64 368C28.65 368 0 339.3 0 304C0 268.7 28.65 240 64 240C93.82 240 118.9 260.4 125.1 288H225.1C229.8 255.3 248.7 227.1 275.3 209.9L237.1 126.7C232.9 127.5 228.5 128 224 128C188.7 128 160 99.35 160 64V64zM224 96C241.7 96 256 81.67 256 64C256 46.33 241.7 32 224 32C206.3 32 192 46.33 192 64C192 81.67 206.3 96 224 96zM576 160C593.7 160 608 145.7 608 128C608 110.3 593.7 96 576 96C558.3 96 544 110.3 544 128C544 145.7 558.3 160 576 160zM576 416C558.3 416 544 430.3 544 448C544 465.7 558.3 480 576 480C593.7 480 608 465.7 608 448C608 430.3 593.7 416 576 416zM64 336C81.67 336 96 321.7 96 304C96 286.3 81.67 272 64 272C46.33 272 32 286.3 32 304C32 321.7 46.33 336 64 336zM336 384C380.2 384 416 348.2 416 304C416 259.8 380.2 224 336 224C291.8 224 256 259.8 256 304C256 348.2 291.8 384 336 384z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChartNetwork = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;